const TRY_IN_STORE_MAX_PRODUCTS = 3;
export {
  TRY_IN_STORE_MAX_PRODUCTS
};
//# sourceMappingURL=storage.js.map
